import React, { useState } from 'react';

export const translations = {
  de: {
    // Navigation
    posteingang: "Posteingang",
    gesendet: "Gesendet",
    quanten_chat: "Quanten-Chat",
    gruppen_chats: "Gruppen-Chats",
    adressbuch: "Adressbuch",
    mein_profil: "Mein Profil",
    identitaets_assistent: "Identitäts-Assistent",
    sperren: "Sperren",
    logout: "Abmelden",
    dunkler_modus: " Dunkler Modus",
    heller_modus: " Heller Modus",
    active_identity: "Aktive Identität",
    setup_profile: "Im Profil einrichten",

    // Quantum Shield
    quantum_shield_status: " Quantum Shield Status",
    post_quantum_e2e: "Post-Quanten E2E",
    aktiviert: "Aktiviert",
    quantum_shield_desc: "Das GaiaCOM-Netzwerk schützt Ihre Privatsphäre mit einem mehrschichtigen, hybriden Verschlüsselungs-Protokoll, das gegen Angriffe von zukünftigen Quantencomputern geschützt ist.",
    quantum_shield_l1_title: "1. Post-Quanten-Schutz (ML-KEM-1024)",
    quantum_shield_l1_desc: "Verwendet den FIPS 203 Standard zur Kapselung eines symmetrischen gemeinsamen Schlüssels. Verhindert das passive Aufzeichnen und spätere Entschlüsseln (\"Store Now, Decrypt Later\") durch Quantencomputer.",
    quantum_shield_l2_title: "2. Elliptic-Curve-Kryptografie (X25519)",
    quantum_shield_l2_desc: "Ein klassisches, extrem schnelles Diffie-Hellman-Schlüsselaustauschverfahren, das als zusätzliche Sicherheitsebene im Hybridverfahren dient.",
    quantum_shield_l3_title: "3. Digitale Signaturen (Ed25519)",
    quantum_shield_l3_desc: "Jede Nachricht und jeder Föderations-Umschlag wird kryptographisch signiert, um die Authentizität des Absenders zweifelsfrei zu verifizieren.",
    quantum_shield_l4_title: "4. AAD Authentifizierung (AES-256-GCM)",
    quantum_shield_l4_desc: "Verschlüsselt Nachrichteninhalte symmetrisch und bindet Absender, Empfänger und Metadaten fest in die Authentifizierten Zusatzdaten (AAD) ein, um Replay-Angriffe zu verhindern.",
    close: "Schließen",

    // Auth Screen
    auth_headline: "Post-Quantum sichere Kommunikation für Menschen und Teams.",
    auth_subline: "GaiaCOM verschlüsselt Inhalte vor dem Transport auf deinem Gerät. Nachrichten, Dateien und GaiaData bleiben kryptographisch gebunden, statt als lose Metadaten auf Serververtrauen zu setzen.",
    auth_proof_e2ee_desc: "Private Schlüssel verlassen dein Gerät nicht.",
    auth_proof_gaiadata_desc: "Kontext wird authentifiziert, nicht blind exponiert.",
    auth_proof_hybrid_desc: "Classical + Post-Quantum Schutz für Beta 1.x.",
    auth_secure_mail: "Secure Quantum Federated Mail",
    auth_username: "Benutzername",
    auth_username_placeholder: "Name eingeben...",
    auth_password: "Passwort",
    auth_password_placeholder: "••••••••••••",
    auth_mnemonic: "Mnemonic-Phrase",
    auth_mnemonic_placeholder: "12 Wörter durch Leerzeichen getrennt...",
    auth_generate_seed: "Seed generieren",
    auth_copy_seed: "Seed kopieren",
    auth_copied: "Kopiert",
    auth_btn_register: "Registrieren & Krypto erstellen",
    auth_btn_login: "Identität laden & einloggen",
    auth_toggle_register: "Neuen Account erstellen",
    auth_toggle_login: "Bereits Account vorhanden",
    auth_success_title: "Registrierung erfolgreich",
    auth_success_text: "Dein GaiaCOM-Konto wurde erstellt. Die Schlüssel wurden lokal aus deinem Seed abgeleitet und nicht auf dem Server gespeichert.",
    auth_success_btn: "Jetzt einloggen",

    // Unlock Screen
    unlock_title: "Identität entsperren",
    unlock_desc: "Deine private Schlüsseldatei ist verschlüsselt gespeichert. Gib dein Passwort ein, um die kryptographischen Schlüssel nur im Arbeitsspeicher zu laden.",
    unlock_btn: "Entsperren",
    unlock_logout: "Abmelden und lokale Schlüssel schließen",

    // Setup Wizard
    wizard_step1: "1. Backup Seed",
    wizard_step2: "2. Adresse & Server",
    wizard_title1: "Wiederherstellungs-Schlüssel sichern",
    wizard_desc1: "GaiaCOM speichert private Schlüssel nicht serverseitig. Ohne Mnemonic Seed kann niemand verlorene Nachrichten wiederherstellen.",
    wizard_check1: "Ich habe meinen Seed sicher gespeichert.",
    wizard_next: "Weiter",
    wizard_title2: "GaiaCOM-Adresse wählen",
    wizard_desc2: "Deine Adresse bestimmt den föderierten Node, über den verschlüsselte Umschläge geroutet werden.",
    wizard_address: "Adresse",
    wizard_custom_domain: "Eigene Domain verwenden",
    wizard_fallback: "Fallback Nodes",
    wizard_back: "Zurück",
    wizard_finish: "Einrichtung abschließen",

    // Group Settings Modal
    group_settings_title: "Gruppeneinstellungen",
    group_settings_name: "Gruppenname",
    group_settings_desc: "Beschreibung",
    group_settings_avatar: "Avatar",

    // General UI
    erfolg: "Erfolg",
    fehler: "Fehler",
    abbrechen: "Abbrechen",
    speichern: "Speichern",
    senden: "Senden",
    antworten: "Antworten",
    gruppe_erstellen: "+ Gruppe erstellen",
    gruppe_beitreten: "Gruppe beigetreten",
    gruppe_verlassen: "Gruppe verlassen",
    einladungscode: "Einladungscode",
    code_kopieren: "Code kopieren",
    kopiert: "Kopiert",
    mitglieder: "Mitglieder",
    kanaele: "Kanäle",
    kanal_erstellen: "+ Kanal",
    mitglied: "Mitglied",
    admin: "Admin",
    suchen: "Neue Gaia-Adresse suchen...",
    profil: "Profil",
    keine_mails: "Keine Mails vorhanden.",
    laden: "Laden...",
    schluessel_entsperrt: "🔑 Schlüssel wieder sperren",

    // Profile & Password Change
    profile_details: "Profil-Details",
    biography: "Biografie",
    no_specification: "Keine Angabe",
    active_identities: "Aktive Identitäten",
    new_identity: "Neue Identität",
    setup_address_keys: "Adresse und Schlüsselsatz anlegen",
    display_name: "Anzeigename",
    bio_status: "Biografie / Status",
    choose_avatar: "Avatar wählen",
    save_profile: "Profil speichern",
    change_password_title: "Passwort ändern",
    change_password_desc: "Ändert dein serverseitiges Login-Passwort. Deine lokale Recovery Phrase bleibt separat durch dein Vault-/Unlock-Passwort geschützt.",
    current_password: "Aktuelles Passwort",
    new_password: "Neues Passwort",
    confirm_new_password: "Neues Passwort bestätigen",
    update_password: "Passwort aktualisieren",

    // Placeholders & Info
    select_contact_chat: "Wähle einen Kontakt aus dem linken Panel aus, um einen quantensicheren E2E-Chat zu starten.",
    select_mail_read: "Wähle eine Mail aus der Liste aus, um deren quantensichere Inhalte zu lesen, oder erstelle eine neue Nachricht.",
    quantum_secure_net: "GaiaCOM Quantensicheres Netzwerk (Ed25519 & ML-KEM)",
    quantum_secure_exchange: "Quantensicherer Austausch über...",

    // GaiaVault
    vault_title: "GaiaVault Secure Records",
    vault_desc: "Lokaler verschlüsselter Tresor für Recovery-Backups, Identitätsnotizen, Server-Zugänge, Notfallkontakte, Rechtsnotizen, Security Events und private Logs.",
    vault_pwd_placeholder: "Vault-Passwort eingeben...",
    vault_btn_unlock: "Tresor entsperren",
    vault_record_title_placeholder: "Titel des Secure Records",
    vault_record_body_placeholder: "Verschlüsselten Record-Inhalt eingeben...",
    vault_btn_encrypt: "Record verschlüsseln",
    vault_btn_lock: "Tresor sperren",
    vault_empty: "Noch keine Secure Records gespeichert.",
    delete: "Löschen",

    // GaiaDrop
    drop_title: "GaiaDrop Secure Inbox",
    drop_desc: "Text-only Zero-Knowledge Drop-Kanal für externe Hinweise, Responsible Disclosure und vertrauliche Meldungen. Externe können ohne Account unter Angabe deiner GaiaID Nachrichten senden.",
    drop_btn_decrypting: "Inbox wird entschlüsselt...",
    drop_btn_load: "GaiaDrop Inbox laden",
    drop_empty: "Noch keine GaiaDrop Meldungen geladen.",
    anonymous_sender: "Anonymer Absender",
    time_unknown: "Zeitpunkt unbekannt",
    decrypt_failed: "Nicht entschlüsselbar",

    // New keys for V2
    confirm_delete_msg: "Möchtest du diese Nachricht löschen?",
    confirm_delete_everyone: "Möchtest du die Nachricht für beide Partner löschen? (OK = Für alle, Abbrechen = Nur für mich)",
    confirm_clear_chat: "Möchtest du diesen Chat leeren?",
    confirm_clear_everyone: "Möchtest du den Chat für beide Partner leeren? (OK = Für alle, Abbrechen = Nur für mich)",
    edit_profile: "Profil bearbeiten",
    click_to_write_mail: "Klicken zum Schreiben einer Mail",
    message_to_channel: "Nachricht an",
    smtp_security_warning: "Diese Mail wurde über das klassische, unverschlüsselte SMTP-Protokoll übertragen. Keine End-to-End-Verschlüsselung aktiv.",
    von: "Von",
    export_disclosure: "Sicherheitsfall exportieren",
    melden: "Melden",
    attachments: "Anhänge",
    kein_chat_ausgewaehlt: "Kein Chat ausgewählt",
    room_chat_start_hint: "Starten Sie die Konversation! Alle Nachrichten in diesem Gruppenkanal sind dezentral quantensicher E2E verschlüsselt.",
    kein_kanal_ausgewaehlt: "Kein Kanal ausgewählt",
    select_channel_chat: "Wähle einen Kanal aus der linken Seitenleiste aus, um zu chatten.",
    chat_start_hint: "Starten Sie die Konversation! Alle Chat-Nachrichten sind quantensicher E2E verschlüsselt.",
    chat_input_placeholder: "Sichere Nachricht eingeben...",
    upload_avatar_btn: "Bild hochladen (Sanitized)",
    kryptographische_schluessel: "Kryptographische Schlüssel",
    profile_unlock_desc: "Aus Sicherheitsgründen müssen Sie Ihr Passwort erneut eingeben, um Ihre privaten kryptographischen Schlüssel anzuzeigen.",
    unlock_btn_profile: "Freischalten",
    e2e_chat_room_open: "E2E Chat-Raum öffnen",
    spam_verdacht: "Spam/Verdacht",
    no_description: "Keine Beschreibung"
  },
  en: {
    // Navigation
    posteingang: "Inbox",
    gesendet: "Sent",
    quanten_chat: "Quantum Chat",
    gruppen_chats: "Group Chats",
    adressbuch: "Address Book",
    mein_profil: "My Profile",
    identitaets_assistent: "Identity Wizard",
    sperren: "Lock",
    logout: "Log Out",
    dunkler_modus: " Dark Mode",
    heller_modus: " Light Mode",
    active_identity: "Active Identity",
    setup_profile: "Setup in Profile",

    // Quantum Shield
    quantum_shield_status: " Quantum Shield Status",
    post_quantum_e2e: "Post-Quantum E2E",
    aktiviert: "Enabled",
    quantum_shield_desc: "The GaiaCOM network protects your privacy with a multi-layered, hybrid encryption protocol secure against attacks from future quantum computers.",
    quantum_shield_l1_title: "1. Post-Quantum Protection (ML-KEM-1024)",
    quantum_shield_l1_desc: "Uses the FIPS 203 standard to encapsulate a symmetric shared key. Prevents passive eavesdropping and later decryption (\"Store Now, Decrypt Later\") by quantum computers.",
    quantum_shield_l2_title: "2. Elliptic-Curve Cryptography (X25519)",
    quantum_shield_l2_desc: "A classical, ultra-fast Diffie-Hellman key exchange method serving as an additional security layer in the hybrid scheme.",
    quantum_shield_l3_title: "3. Digital Signatures (Ed25519)",
    quantum_shield_l3_desc: "Every message and federation envelope is cryptographically signed to verify sender authenticity beyond doubt.",
    quantum_shield_l4_title: "4. AAD Authentication (AES-256-GCM)",
    quantum_shield_l4_desc: "Encrypts message content symmetrically and binds sender, recipient, and metadata tightly into the Authenticated Additional Data (AAD) to prevent replay attacks.",
    close: "Close",

    // Auth Screen
    auth_headline: "Post-Quantum secure communication for people and teams.",
    auth_subline: "GaiaCOM encrypts content on your device before transport. Messages, files, and GaiaData remain cryptographically bound, instead of relying on server trust.",
    auth_proof_e2ee_desc: "Private keys never leave your device.",
    auth_proof_gaiadata_desc: "Context is authenticated, not blindly exposed.",
    auth_proof_hybrid_desc: "Classical + Post-Quantum protection for Beta 1.x.",
    auth_secure_mail: "Secure Quantum Federated Mail",
    auth_username: "Username",
    auth_username_placeholder: "Enter username...",
    auth_password: "Password",
    auth_password_placeholder: "••••••••••••",
    auth_mnemonic: "Mnemonic Phrase",
    auth_mnemonic_placeholder: "12 words separated by spaces...",
    auth_generate_seed: "Generate Seed",
    auth_copy_seed: "Copy Seed",
    auth_copied: "Copied",
    auth_btn_register: "Register & Create Keys",
    auth_btn_login: "Load Identity & Log In",
    auth_toggle_register: "Create new account",
    auth_toggle_login: "Already have an account",
    auth_success_title: "Registration Successful",
    auth_success_text: "Your GaiaCOM account has been created. The keys were derived locally from your seed and not stored on the server.",
    auth_success_btn: "Log In Now",

    // Unlock Screen
    unlock_title: "Unlock Identity",
    unlock_desc: "Your private key file is stored encrypted. Enter your password to load the cryptographic keys only in RAM.",
    unlock_btn: "Unlock",
    unlock_logout: "Log out and close local keys",

    // Setup Wizard
    wizard_step1: "1. Backup Seed",
    wizard_step2: "2. Address & Server",
    wizard_title1: "Secure Recovery Keys",
    wizard_desc1: "GaiaCOM does not store private keys server-side. Without the Mnemonic Seed, no one can recover lost messages.",
    wizard_check1: "I have securely stored my seed.",
    wizard_next: "Next",
    wizard_title2: "Select GaiaCOM Address",
    wizard_desc2: "Your address determines the federated node through which encrypted envelopes are routed.",
    wizard_address: "Address",
    wizard_custom_domain: "Use custom domain",
    wizard_fallback: "Fallback Nodes",
    wizard_back: "Back",
    wizard_finish: "Finish Setup",

    // Group Settings Modal
    group_settings_title: "Group Settings",
    group_settings_name: "Group Name",
    group_settings_desc: "Description",
    group_settings_avatar: "Avatar",

    // General UI
    erfolg: "Success",
    fehler: "Error",
    abbrechen: "Cancel",
    speichern: "Save",
    senden: "Send",
    antworten: "Reply",
    gruppe_erstellen: "+ Create Group",
    gruppe_beitreten: "Group Joined",
    gruppe_verlassen: "Leave Group",
    einladungscode: "Invite Code",
    code_kopieren: "Copy Code",
    kopiert: "Copied",
    mitglieder: "Members",
    kanaele: "Channels",
    kanal_erstellen: "+ Channel",
    mitglied: "Member",
    admin: "Admin",
    suchen: "Search Gaia address...",
    profil: "Profile",
    keine_mails: "No mails available.",
    laden: "Loading...",
    schluessel_entsperrt: "🔑 Lock keys again",

    // Profile & Password Change
    profile_details: "Profile Details",
    biography: "Biography",
    no_specification: "No specification",
    active_identities: "Active Identities",
    new_identity: "New Identity",
    setup_address_keys: "Create address and keys",
    display_name: "Display Name",
    bio_status: "Biography / Status",
    choose_avatar: "Choose Avatar",
    save_profile: "Save Profile",
    change_password_title: "Change Password",
    change_password_desc: "Changes your server-side login password. Your local recovery phrase remains separate and protected by your Vault/Unlock password.",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_new_password: "Confirm New Password",
    update_password: "Update Password",

    // Placeholders & Info
    select_contact_chat: "Select a contact from the left panel to start a quantum-secure E2E chat.",
    select_mail_read: "Select a mail from the list to read its quantum-secure contents, or create a new message.",
    quantum_secure_net: "GaiaCOM Quantum-Secure Network (Ed25519 & ML-KEM)",
    quantum_secure_exchange: "Quantum-secure exchange via...",

    // GaiaVault
    vault_title: "GaiaVault Secure Records",
    vault_desc: "Local encrypted vault for recovery backups, identity notes, server credentials, emergency contacts, legal notes, security events, and private logs.",
    vault_pwd_placeholder: "Enter Vault password...",
    vault_btn_unlock: "Unlock Vault",
    vault_record_title_placeholder: "Title of Secure Record",
    vault_record_body_placeholder: "Enter encrypted record content...",
    vault_btn_encrypt: "Encrypt Record",
    vault_btn_lock: "Lock Vault",
    vault_empty: "No secure records stored yet.",
    delete: "Delete",

    // GaiaDrop
    drop_title: "GaiaDrop Secure Inbox",
    drop_desc: "Text-only zero-knowledge drop channel for external hints, responsible disclosure, and confidential reports. External users can send messages using your GaiaID without an account.",
    drop_btn_decrypting: "Decrypting inbox...",
    drop_btn_load: "Load GaiaDrop Inbox",
    drop_empty: "No GaiaDrop messages loaded yet.",
    anonymous_sender: "Anonymous Sender",
    time_unknown: "Time unknown",
    decrypt_failed: "Not decryptable",

    // New keys for V2
    confirm_delete_msg: "Do you want to delete this message?",
    confirm_delete_everyone: "Do you want to delete this message for both partners? (OK = For everyone, Cancel = Only for me)",
    confirm_clear_chat: "Do you want to clear this chat?",
    confirm_clear_everyone: "Do you want to clear this chat for both partners? (OK = For everyone, Cancel = Only for me)",
    edit_profile: "Edit Profile",
    click_to_write_mail: "Click to write an email",
    message_to_channel: "Message to",
    smtp_security_warning: "This mail was transmitted via the classical, unencrypted SMTP protocol. No End-to-End encryption active.",
    von: "From",
    export_disclosure: "Export Disclosure",
    melden: "Report",
    attachments: "Attachments",
    kein_chat_ausgewaehlt: "No chat selected",
    room_chat_start_hint: "Start the conversation! All messages in this group channel are decentralized, quantum-secure E2E encrypted.",
    kein_kanal_ausgewaehlt: "No channel selected",
    select_channel_chat: "Select a channel from the left sidebar to start chatting.",
    chat_start_hint: "Start the conversation! All chat messages are quantum-secure E2E encrypted.",
    chat_input_placeholder: "Enter secure message...",
    upload_avatar_btn: "Upload Image (Sanitized)",
    kryptographische_schluessel: "Cryptographic Keys",
    profile_unlock_desc: "For security reasons, you must enter your password again to view your private cryptographic keys.",
    unlock_btn_profile: "Unlock",
    e2e_chat_room_open: "Open E2E Chat Room",
    spam_verdacht: "Spam/Suspected",
    no_description: "No description"
  },
  ru: {
    // Navigation
    posteingang: "Входящие",
    gesendet: "Отправленные",
    quanten_chat: "Квантовый чат",
    gruppen_chats: "Групповые чаты",
    adressbuch: "Адресная книга",
    mein_profil: "Мой профиль",
    identitaets_assistent: "Помощник личности",
    sperren: "Заблокировать",
    logout: "Выйти",
    dunkler_modus: " Тёмная тема",
    heller_modus: " Светлая тема",
    active_identity: "Активная личность",
    setup_profile: "Настроить в профиле",

    // Quantum Shield
    quantum_shield_status: " Статус Quantum Shield",
    post_quantum_e2e: "Постквантовый E2E",
    aktiviert: "Активирован",
    quantum_shield_desc: "Сеть GaiaCOM защищает вашу конфиденциальность с помощью многоуровневого гибридного протокола шифрования, устойчивого к атакам будущих квантовых компьютеров.",
    quantum_shield_l1_title: "1. Постквантовая защита (ML-KEM-1024)",
    quantum_shield_l1_desc: "Использует стандарт FIPS 203 для инкапсуляции симметричного общего ключа. Предотвращает пассивный перехват и последующую расшифровку (\"Запиши сейчас, расшифруй потом\") квантовыми компьютерами.",
    quantum_shield_l2_title: "2. Эллиптическая криптография (X25519)",
    quantum_shield_l2_desc: "Классический, сверхбыстрый метод обмена ключами Диффи-Хеллмана, служащий дополнительным уровнем безопасности в гибридной схеме.",
    quantum_shield_l3_title: "3. Цифровые подписи (Ed25519)",
    quantum_shield_l3_desc: "Каждое сообщение и федеративный конверт подписываются криптографически, чтобы однозначно подтвердить подлинность отправителя.",
    quantum_shield_l4_title: "4. AAD аутентификация (AES-256-GCM)",
    quantum_shield_l4_desc: "Шифрует содержимое сообщений симметрично и жестко привязывает отправителя, получателя и метаданные к аутентифицированным дополнительным данным (AAD) для предотвращения атак повторного воспроизведения.",
    close: "Закрыть",

    // Auth Screen
    auth_headline: "Безопасная постквантовая связь для людей и команд.",
    auth_subline: "GaiaCOM шифрует контент на вашем устройстве перед транспортировкой. Сообщения, файлы и данные GaiaData остаются криптографически связанными, а не зависят от доверия серверу.",
    auth_proof_e2ee_desc: "Закрытые ключи никогда не покидают ваше устройство.",
    auth_proof_gaiadata_desc: "Контекст аутентифицируется, а не раскрывается слепо.",
    auth_proof_hybrid_desc: "Классическая + постквантовая защита для бета-версии 1.х.",
    auth_secure_mail: "Безопасная квантовая федеративная почта",
    auth_username: "Имя пользователя",
    auth_username_placeholder: "Введите имя...",
    auth_password: "Пароль",
    auth_password_placeholder: "••••••••••••",
    auth_mnemonic: "Мнемоническая фраза",
    auth_mnemonic_placeholder: "12 слов, разделенных пробелами...",
    auth_generate_seed: "Сгенерировать сид",
    auth_copy_seed: "Копировать сид",
    auth_copied: "Скопировано",
    auth_btn_register: "Регистрация и создание ключей",
    auth_btn_login: "Загрузить личность и войти",
    auth_toggle_register: "Создать новый аккаунт",
    auth_toggle_login: "Уже есть аккаунт",
    auth_success_title: "Регистрация успешна",
    auth_success_text: "Ваш аккаунт GaiaCOM создан. Ключи были созданы локально из вашего сида и не хранятся на сервере.",
    auth_success_btn: "Войти сейчас",

    // Unlock Screen
    unlock_title: "Разблокировать личность",
    unlock_desc: "Файл вашего закрытого ключа зашифрован. Введите пароль для загрузки криптографических ключей только в оперативную память.",
    unlock_btn: "Разблокировать",
    unlock_logout: "Выйти и закрыть локальные ключи",

    // Setup Wizard
    wizard_step1: "1. Резервный сид",
    wizard_step2: "2. Адрес и Сервер",
    wizard_title1: "Защитить ключи восстановления",
    wizard_desc1: "GaiaCOM не хранит закрытые ключи на стороне сервера. Без мнемонического сида никто не сможет восстановить утерянные сообщения.",
    wizard_check1: "Я надежно сохранил свою сид-фразу.",
    wizard_next: "Далее",
    wizard_title2: "Выберите адрес GaiaCOM",
    wizard_desc2: "Ваш адрес определяет федеративный узел, через который маршрутизируются зашифрованные конверты.",
    wizard_address: "Адрес",
    wizard_custom_domain: "Использовать свой домен",
    wizard_fallback: "Резервные узлы",
    wizard_back: "Назад",
    wizard_finish: "Завершить настройку",

    // Group Settings Modal
    group_settings_title: "Настройки группы",
    group_settings_name: "Название группы",
    group_settings_desc: "Описание",
    group_settings_avatar: "Аватар",

    // General UI
    erfolg: "Успех",
    fehler: "Ошибка",
    abbrechen: "Отмена",
    speichern: "Сохранить",
    senden: "Отправить",
    antworten: "Ответить",
    gruppe_erstellen: "+ Создать группу",
    gruppe_beitreten: "Группа присоединена",
    gruppe_verlassen: "Выйти из группы",
    einladungscode: "Код приглашения",
    code_kopieren: "Копировать код",
    kopiert: "Скопировано",
    mitglieder: "Участники",
    kanaele: "Каналы",
    kanal_erstellen: "+ Канал",
    mitglied: "Участник",
    admin: "Админ",
    suchen: "Поиск адреса Gaia...",
    profil: "Профиль",
    keine_mails: "Нет писем.",
    laden: "Загрузка...",
    schluessel_entsperrt: "🔑 Снова заблокировать ключи",

    // Profile & Password Change
    profile_details: "Детали профиля",
    biography: "Биография",
    no_specification: "Не указано",
    active_identities: "Активные личности",
    new_identity: "Новая личность",
    setup_address_keys: "Создать адрес и набор ключей",
    display_name: "Отображаемое имя",
    bio_status: "Биография / Статус",
    choose_avatar: "Выбрать аватар",
    save_profile: "Сохранить профиль",
    change_password_title: "Изменить пароль",
    change_password_desc: "Изменяет ваш пароль для входа на сервере. Ваша локальная резервная фраза остается отдельно защищенной паролем Vault/Unlock.",
    current_password: "Текущий пароль",
    new_password: "Новый пароль",
    confirm_new_password: "Подтвердить новый пароль",
    update_password: "Обновить пароль",

    // Placeholders & Info
    select_contact_chat: "Выберите контакт на левой панели, чтобы начать безопасный квантово-защищенный чат E2E.",
    select_mail_read: "Выберите письмо из списка, чтобы прочитать его квантово-безопасное содержимое, или создайте новое сообщение.",
    quantum_secure_net: "Квантово-безопасная сеть GaiaCOM (Ed25519 и ML-KEM)",
    quantum_secure_exchange: "Квантово-безопасный обмен через...",

    // GaiaVault
    vault_title: "Сейф GaiaVault Secure Records",
    vault_desc: "Локальный зашифрованный сейф для резервных копий восстановления, личных заметок, учетных данных серверов, экстренных контактов, юридических заметок, событий безопасности и частных логов.",
    vault_pwd_placeholder: "Введите пароль сейфа...",
    vault_btn_unlock: "Разблокировать сейф",
    vault_record_title_placeholder: "Название записи",
    vault_record_body_placeholder: "Введите зашифрованное содержимое записи...",
    vault_btn_encrypt: "Зашифровать запись",
    vault_btn_lock: "Заблокировать сейф",
    vault_empty: "В сейфе пока нет сохраненных записей.",
    delete: "Удалить",

    // GaiaDrop
    drop_title: "Приемник GaiaDrop Secure Inbox",
    drop_desc: "Текстовый канал с нулевым разглашением для внешних сообщений, раскрытия уязвимостей и конфиденциальных отчетов. Внешние пользователи могут отправлять сообщения на ваш GaiaID без аккаунта.",
    drop_btn_decrypting: "Дешифрование папки...",
    drop_btn_load: "Загрузить GaiaDrop Inbox",
    drop_empty: "Входящих сообщений GaiaDrop пока нет.",
    anonymous_sender: "Анонимный отправитель",
    time_unknown: "Время неизвестно",
    decrypt_failed: "Не удается расшифровать",

    // New keys for V2
    confirm_delete_msg: "Вы хотите удалить это сообщение?",
    confirm_delete_everyone: "Вы хотите удалить это сообщение для обеих сторон? (OK = Для всех, Отмена = Только для меня)",
    confirm_clear_chat: "Вы хотите очистить этот чат?",
    confirm_clear_everyone: "Вы хотите очистить этот чат для обеих сторон? (OK = Для всех, Отмена = Только для меня)",
    edit_profile: "Редактировать профиль",
    click_to_write_mail: "Нажмите, чтобы написать письмо",
    message_to_channel: "Сообщение в",
    smtp_security_warning: "Это письмо было передано по классическому незашифрованному протоколу SMTP. Сквозное шифрование неактивно.",
    von: "От",
    export_disclosure: "Экспорт дела безопасности",
    melden: "Пожаловаться",
    attachments: "Вложения",
    kein_chat_ausgewaehlt: "Чат не выбран",
    room_chat_start_hint: "Начните беседу! Все сообщения в этом групповом канале децентрализованы и защищены сквозным квантово-безопасным шифрованием.",
    kein_kanal_ausgewaehlt: "Канал не выбран",
    select_channel_chat: "Выберите канал в левой боковой панели, чтобы начать чат.",
    chat_start_hint: "Начните разговор! Все сообщения в чате защищены квантово-безопасным сквозным шифрованием.",
    chat_input_placeholder: "Введите безопасное сообщение...",
    upload_avatar_btn: "Загрузить изображение (очищенное)",
    kryptographische_schluessel: "Криптографические ключи",
    profile_unlock_desc: "По соображениям безопасности вам необходимо ввести свой пароль еще раз, чтобы просмотреть свои закрытые криптографические ключи.",
    unlock_btn_profile: "Разблокировать",
    e2e_chat_room_open: "Открыть чат-комнату E2E",
    spam_verdacht: "Спам/Подозрение",
    no_description: "Нет описания"
  },
  es: {
    // Navigation
    posteingang: "Bandeja de entrada",
    gesendet: "Enviados",
    quanten_chat: "Chat Cuántico",
    gruppen_chats: "Chats de Grupo",
    adressbuch: "Libreta de Direcciones",
    mein_profil: "Mi Perfil",
    identitaets_assistent: "Asistente de Identidad",
    sperren: "Bloquear",
    logout: "Cerrar sesión",
    dunkler_modus: " Modo Oscuro",
    heller_modus: " Modo Claro",
    active_identity: "Identidad Activa",
    setup_profile: "Configurar en el Perfil",

    // Quantum Shield
    quantum_shield_status: " Estado del Quantum Shield",
    post_quantum_e2e: "E2E Post-Cuántico",
    aktiviert: "Activado",
    quantum_shield_desc: "La red GaiaCOM protege su privacidad con un protocolo de cifrado híbrido multicapa seguro contra ataques de futuros ordenadores cuánticos.",
    quantum_shield_l1_title: "1. Protección Post-Cuántica (ML-KEM-1024)",
    quantum_shield_l1_desc: "Utiliza el estándar FIPS 203 para encapsular una clave compartida simétrica. Evita la escucha pasiva y el descifrado posterior (\"Grabe ahora, descifre más tarde\") por parte de ordenadores cuánticos.",
    quantum_shield_l2_title: "2. Criptografía de Curva Elíptica (X25519)",
    quantum_shield_l2_desc: "Un método de intercambio de claves Diffie-Hellman clásico y ultrarrápido que sirve como capa de seguridad adicional en el esquema híbrido.",
    quantum_shield_l3_title: "3. Firmas Digitales (Ed25519)",
    quantum_shield_l3_desc: "Cada mensaje y sobre de federación está firmado criptográficamente para verificar la autenticidad del remitente fuera de toda duda.",
    quantum_shield_l4_title: "4. Autenticación AAD (AES-256-GCM)",
    quantum_shield_l4_desc: "Cifra el contenido del mensaje de forma simétrica y une estrechamente al remitente, destinatario y metadatos en los Datos Adicionales Autenticados (AAD) para evitar ataques de reproducción.",
    close: "Cerrar",

    // Auth Screen
    auth_headline: "Comunicación post-cuántica segura para personas y equipos.",
    auth_subline: "GaiaCOM cifra el contenido en su dispositivo antes del transporte. Los mensajes, archivos y GaiaData permanecen vinculados criptográficamente, en lugar de depender de la confianza en el servidor.",
    auth_proof_e2ee_desc: "Las llaves privadas nunca salen de su dispositivo.",
    auth_proof_gaiadata_desc: "El contexto se autentica, no se expone a ciegas.",
    auth_proof_hybrid_desc: "Protección clásica + post-cuántica para Beta 1.x.",
    auth_secure_mail: "Correo Federado Cuántico Seguro",
    auth_username: "Nombre de usuario",
    auth_username_placeholder: "Ingrese el nombre...",
    auth_password: "Contraseña",
    auth_password_placeholder: "••••••••••••",
    auth_mnemonic: "Frase mnemónica",
    auth_mnemonic_placeholder: "12 palabras separadas por espacios...",
    auth_generate_seed: "Generar semilla",
    auth_copy_seed: "Copiar semilla",
    auth_copied: "Copiado",
    auth_btn_register: "Registrarse y Crear Cripto",
    auth_btn_login: "Cargar Identidad e Iniciar Sesión",
    auth_toggle_register: "Crear nueva cuenta",
    auth_toggle_login: "Ya tengo una cuenta",
    auth_success_title: "Registro Exitoso",
    auth_success_text: "Su cuenta de GaiaCOM ha sido creada. Las claves se derivaron localmente de su semilla y no se almacenaron en el servidor.",
    auth_success_btn: "Iniciar Sesión Ahora",

    // Unlock Screen
    unlock_title: "Desbloquear Identidad",
    unlock_desc: "Su archivo de clave privada está almacenado de forma encriptada. Ingrese su contraseña para cargar las claves criptográficas solo en la memoria RAM.",
    unlock_btn: "Desbloquear",
    unlock_logout: "Cerrar sesión y cerrar claves locales",

    // Setup Wizard
    wizard_step1: "1. Copia de Semilla",
    wizard_step2: "2. Dirección y Servidor",
    wizard_title1: "Asegurar Claves de Recuperación",
    wizard_desc1: "GaiaCOM no almacena claves privadas en el servidor. Sin la semilla mnemónica, nadie puede recuperar mensajes perdidos.",
    wizard_check1: "He guardado de forma segura mi frase semilla.",
    wizard_next: "Siguiente",
    wizard_title2: "Seleccionar Dirección GaiaCOM",
    wizard_desc2: "Su dirección determina el nodo federado a través del cual se enrutan los sobres cifrados.",
    wizard_address: "Dirección",
    wizard_custom_domain: "Usar dominio personalizado",
    wizard_fallback: "Nodos de Respaldo",
    wizard_back: "Atrás",
    wizard_finish: "Finalizar Configuración",

    // Group Settings Modal
    group_settings_title: "Configuración de Grupo",
    group_settings_name: "Nombre de Grupo",
    group_settings_desc: "Descripción",
    group_settings_avatar: "Avatar",

    // General UI
    erfolg: "Éxito",
    fehler: "Error",
    abbrechen: "Cancelar",
    speichern: "Guardar",
    senden: "Enviar",
    antworten: "Responder",
    gruppe_erstellen: "+ Crear Grupo",
    gruppe_beitreten: "Grupo Unido",
    gruppe_verlassen: "Salir del Grupo",
    einladungscode: "Código de Invitación",
    code_kopieren: "Copiar Código",
    kopiert: "Copiado",
    mitglieder: "Miembros",
    kanaele: "Canales",
    kanal_erstellen: "+ Canal",
    mitglied: "Miembro",
    admin: "Administrador",
    suchen: "Buscar dirección Gaia...",
    profil: "Perfil",
    keine_mails: "No hay correos disponibles.",
    laden: "Cargando...",
    schluessel_entsperrt: "🔑 Bloquear llaves de nuevo",

    // Profile & Password Change
    profile_details: "Detalles del Perfil",
    biography: "Biografía",
    no_specification: "Sin especificar",
    active_identities: "Identidades Activas",
    new_identity: "Nueva Identidad",
    setup_address_keys: "Crear dirección y llaves",
    display_name: "Nombre de Mostrar",
    bio_status: "Biografía / Estado",
    choose_avatar: "Elegir Avatar",
    save_profile: "Guardar Perfil",
    change_password_title: "Cambiar Contraseña",
    change_password_desc: "Cambia tu contraseña de inicio de sesión en el servidor. Tu frase de recuperación local permanece guardada por separado protegida por tu contraseña de Vault/Unlock.",
    current_password: "Contraseña Actual",
    new_password: "Nueva Contraseña",
    confirm_new_password: "Confirmar Nueva Contraseña",
    update_password: "Actualizar Contraseña",

    // Placeholders & Info
    select_contact_chat: "Selecciona un contacto del panel izquierdo para iniciar un chat E2E seguro cuántico.",
    select_mail_read: "Selecciona un correo de la lista para leer sus contenidos cuántico-seguros, o crea un mensaje nuevo.",
    quantum_secure_net: "Red cuántico-segura GaiaCOM (Ed25519 y ML-KEM)",
    quantum_secure_exchange: "Intercambio cuántico-seguro a través de...",

    // GaiaVault
    vault_title: "Caja Fuerte GaiaVault Secure Records",
    vault_desc: "Caja fuerte encriptada local para copias de seguridad de recuperación, notas de identidad, credenciales de servidor, contactos de emergencia, notas legales, eventos de seguridad y registros privados.",
    vault_pwd_placeholder: "Introduce la contraseña de la caja fuerte...",
    vault_btn_unlock: "Desbloquear Caja Fuerte",
    vault_record_title_placeholder: "Título del registro",
    vault_record_body_placeholder: "Introduce el contenido encriptado del registro...",
    vault_btn_encrypt: "Encriptar Registro",
    vault_btn_lock: "Bloquear Caja Fuerte",
    vault_empty: "No hay registros seguros guardados aún.",
    delete: "Borrar",

    // GaiaDrop
    drop_title: "Buzón Seguro GaiaDrop",
    drop_desc: "Canal de entrega anónimo de texto sin conocimiento previo para pistas externas, revelación responsable e informes confidenciales. Usuarios externos pueden enviar mensajes a tu GaiaID sin cuenta.",
    drop_btn_decrypting: "Descifrando buzón...",
    drop_btn_load: "Cargar GaiaDrop Inbox",
    drop_empty: "No hay mensajes de GaiaDrop cargados aún.",
    anonymous_sender: "Remitente Anónimo",
    time_unknown: "Hora desconocida",
    decrypt_failed: "No descifrable",

    // New keys for V2
    confirm_delete_msg: "¿Quieres borrar este mensaje?",
    confirm_delete_everyone: "¿Quieres borrar este mensaje para ambos? (OK = Para todos, Cancelar = Solo para mí)",
    confirm_clear_chat: "¿Quieres vaciar este chat?",
    confirm_clear_everyone: "¿Quieres vaciar este chat para ambos? (OK = Para todos, Cancelar = Solo para mí)",
    edit_profile: "Editar Perfil",
    click_to_write_mail: "Haz clic para escribir un correo",
    message_to_channel: "Mensaje para",
    smtp_security_warning: "Este correo fue transmitido a través del protocolo clásico SMTP sin cifrar. El cifrado de extremo a extremo no está activo.",
    von: "De",
    export_disclosure: "Exportar caso de seguridad",
    melden: "Reportar",
    attachments: "Adjuntos",
    kein_chat_ausgewaehlt: "Ningún chat seleccionado",
    room_chat_start_hint: "¡Comienza la conversación! Todos los mensajes en este canal de grupo están cifrados E2E de forma descentralizada y segura contra cuántica.",
    kein_kanal_ausgewaehlt: "Ningún canal seleccionado",
    select_channel_chat: "Selecciona un canal de la barra lateral izquierda para chatear.",
    chat_start_hint: "¡Comienza la conversación! Todos los mensajes de chat están cifrados E2E de forma cuántica segura.",
    chat_input_placeholder: "Introduce mensaje seguro...",
    upload_avatar_btn: "Subir imagen (Desinfectada)",
    kryptographische_schluessel: "Llaves Criptográficas",
    profile_unlock_desc: "Por razones de seguridad, debes ingresar tu contraseña nuevamente para ver tus llaves criptográficas privadas.",
    unlock_btn_profile: "Desbloquear",
    e2e_chat_room_open: "Abrir sala de chat E2E",
    spam_verdacht: "Spam/Sospecha",
    no_description: "Sin descripción"
  },
  fr: {
    // Navigation
    posteingang: "Boîte de réception",
    gesendet: "Envoyés",
    quanten_chat: "Chat Quantique",
    gruppen_chats: "Chats de Groupe",
    adressbuch: "Carnet d'Adresses",
    mein_profil: "Mon Profil",
    identitaets_assistent: "Assistant d'Identité",
    sperren: "Verrouiller",
    logout: "Se déconnecter",
    dunkler_modus: " Mode Sombre",
    heller_modus: " Mode Clair",
    active_identity: "Identité Active",
    setup_profile: "Configurer dans le Profil",

    // Quantum Shield
    quantum_shield_status: " Statut du Quantum Shield",
    post_quantum_e2e: "E2E Post-Quantique",
    aktiviert: "Activé",
    quantum_shield_desc: "Le réseau GaiaCOM protège votre vie privée avec un protocole de chiffrement hybride externe multicouche sécurisé contre les attaques des futurs ordinateurs quantiques.",
    quantum_shield_l1_title: "1. Protection Post-Quantique (ML-KEM-1024)",
    quantum_shield_l1_desc: "Utilise la norme FIPS 203 pour encapsuler une clé partagée symétrique. Empêche l'écoute passive et le déchiffrement ultérieur (\"Enregistrez maintenant, déchiffrez plus tard\") par les ordinateurs quantiques.",
    quantum_shield_l2_title: "2. Cryptographie sur Courbe Elliptique (X25519)",
    quantum_shield_l2_desc: "Une méthode classique et ultra-rapide d'échange de clés Diffie-Hellman qui sert de couche de sécurité supplémentaire dans le schéma hybride.",
    quantum_shield_l3_title: "3. Signatures Numériques (Ed25519)",
    quantum_shield_l3_desc: "Chaque message et enveloppe de fédération est signé cryptographiquement pour vérifier l'authenticité de l'expéditeur sans aucun doute.",
    quantum_shield_l4_title: "4. Authentification AAD (AES-256-GCM)",
    quantum_shield_l4_desc: "Chiffre le contenu du message de manière symétrique et lie fermement l'expéditeur, le destinataire et les métadonnées dans les Données Additionnelles Authentifiées (AAD) pour empêcher les attaques par rejeu.",
    close: "Fermer",

    // Auth Screen
    auth_headline: "Communication sécurisée post-quantique pour les personnes et les équipes.",
    auth_subline: "GaiaCOM chiffre le contenu sur votre appareil avant le transport. Les messages, fichiers et GaiaData restent liés par cryptographie, au lieu de s'en remettre à la confiance du serveur.",
    auth_proof_e2ee_desc: "Les clés privées ne quittent jamais votre appareil.",
    auth_proof_gaiadata_desc: "Le contexte est authentifié, pas exposé aveuglément.",
    auth_proof_hybrid_desc: "Protection classique + post-quantique pour Beta 1.x.",
    auth_secure_mail: "Courrier Fédéré Quantique Sécurisé",
    auth_username: "Nom d'utilisateur",
    auth_username_placeholder: "Entrez le nom...",
    auth_password: "Mot de passe",
    auth_password_placeholder: "••••••••••••",
    auth_mnemonic: "Phrase mnémotechnique",
    auth_mnemonic_placeholder: "12 mots séparés par des espaces...",
    auth_generate_seed: "Générer la graine",
    auth_copy_seed: "Copier la graine",
    auth_copied: "Copié",
    auth_btn_register: "S'inscrire & Créer la crypto",
    auth_btn_login: "Charger l'identité & Se connecter",
    auth_toggle_register: "Créer un nouveau compte",
    auth_toggle_login: "J'ai déjà un compte",
    auth_success_title: "Inscription réussie",
    auth_success_text: "Votre compte GaiaCOM a été créé. Les clés ont été dérivées localement de votre graine et ne sont pas stockées sur le serveur.",
    auth_success_btn: "Se connecter maintenant",

    // Unlock Screen
    unlock_title: "Déverrouiller l'identité",
    unlock_desc: "Votre fichier de clé privée est stocké de manière chiffrée. Entrez votre mot de passe pour charger les clés cryptographiques uniquement en mémoire vive.",
    unlock_btn: "Déverrouiller",
    unlock_logout: "Se déconnecter et fermer les clés locales",

    // Setup Wizard
    wizard_step1: "1. Copia de Graine",
    wizard_step2: "2. Adresse et Serveur",
    wizard_title1: "Sécuriser Clés de Récupération",
    wizard_desc1: "GaiaCOM ne stocke pas les clés privées sur le serveur. Sans la graine mnémotechnique, personne ne peut récupérer les messages perdus.",
    wizard_check1: "J'ai sauvegardé ma phrase graine en toute sécurité.",
    wizard_next: "Suivant",
    wizard_title2: "Choisir Adresse GaiaCOM",
    wizard_desc2: "Votre adresse détermine le nœud fédéré par lequel les enveloppes chiffrées sont acheminées.",
    wizard_address: "Adresse",
    wizard_custom_domain: "Utiliser son propre domaine",
    wizard_fallback: "Nœuds de secours",
    wizard_back: "Retour",
    wizard_finish: "Terminer la configuration",

    // Group Settings Modal
    group_settings_title: "Paramètres du Groupe",
    group_settings_name: "Nom du Groupe",
    group_settings_desc: "Description",
    group_settings_avatar: "Avatar",

    // General UI
    erfolg: "Succès",
    fehler: "Erreur",
    abbrechen: "Annuler",
    speichern: "Sauvegarder",
    senden: "Envoyer",
    antworten: "Répondre",
    gruppe_erstellen: "+ Créer un groupe",
    gruppe_beitreten: "Groupe rejoint",
    gruppe_verlassen: "Quitter le groupe",
    einladungscode: "Code d'invitation",
    code_kopieren: "Copier le code",
    kopiert: "Copié",
    mitglieder: "Membres",
    kanaele: "Canaux",
    kanal_erstellen: "+ Canal",
    mitglied: "Membre",
    admin: "Admin",
    suchen: "Rechercher une adresse Gaia...",
    profil: "Profil",
    keine_mails: "Aucun e-mail disponible.",
    laden: "Chargement...",
    schluessel_entsperrt: "🔑 Re-verrouiller les clés",

    // Profile & Password Change
    profile_details: "Détails du Profil",
    biography: "Biographie",
    no_specification: "Non spécifié",
    active_identities: "Identités Actives",
    new_identity: "Nouvelle Identité",
    setup_address_keys: "Créer adresse et clés",
    display_name: "Nom d'Affichage",
    bio_status: "Biographie / Statut",
    choose_avatar: "Choisir l'Avatar",
    save_profile: "Sauvegarder le Profil",
    change_password_title: "Changer de mot de passe",
    change_password_desc: "Modifie votre mot de passe de connexion côté serveur. Votre phrase de récupération locale reste stockée séparément protégée par votre mot de passe de coffre-fort.",
    current_password: "Mot de passe actuel",
    new_password: "Nouveau mot de passe",
    confirm_new_password: "Confirmer le nouveau mot de passe",
    update_password: "Mettre à jour le mot de passe",

    // Placeholders & Info
    select_contact_chat: "Sélectionnez un contact du panneau de gauche pour démarrer une discussion quantique sécurisée E2E.",
    select_mail_read: "Sélectionnez un e-mail dans la liste pour lire son contenu quantique sécurisé, ou créez un nouveau message.",
    quantum_secure_net: "Réseau quantique sécurisé GaiaCOM (Ed25519 & ML-KEM)",
    quantum_secure_exchange: "Échange quantique sécurisé via...",

    // GaiaVault
    vault_title: "Coffre-fort GaiaVault Secure Records",
    vault_desc: "Coffre-fort local chiffré pour sauvegardes de récupération, notes d'identité, identifiants serveur, contacts d'urgence, notes légales, événements de sécurité et journaux privés.",
    vault_pwd_placeholder: "Entrez le mot de passe du coffre-fort...",
    vault_btn_unlock: "Déverrouiller le coffre-fort",
    vault_record_title_placeholder: "Titre de l'enregistrement",
    vault_record_body_placeholder: "Saisir le contenu de l'enregistrement chiffré...",
    vault_btn_encrypt: "Chiffrer l'enregistrement",
    vault_btn_lock: "Verrouiller le coffre-fort",
    vault_empty: "Aucun enregistrement sécurisé stocké pour le moment.",
    delete: "Supprimer",

    // GaiaDrop
    drop_title: "Boîte de dépôt sécurisée GaiaDrop",
    drop_desc: "Canal de dépôt de texte anonyme sans connaissance pour les indices externes, la divulgation responsable et les rapports confidentiels. Les utilisateurs externes peuvent envoyer des messages à votre GaiaID sans compte.",
    drop_btn_decrypting: "Déchiffrement de la boîte...",
    drop_btn_load: "Charger GaiaDrop Inbox",
    drop_empty: "Aucun message GaiaDrop chargé pour le moment.",
    anonymous_sender: "Expéditeur Anonyme",
    time_unknown: "Heure inconnue",
    decrypt_failed: "Non déchiffrable",

    // New keys for V2
    confirm_delete_msg: "Voulez-vous supprimer ce message ?",
    confirm_delete_everyone: "Voulez-vous supprimer ce message pour les deux ? (OK = Pour tout le monde, Annuler = Seulement pour moi)",
    confirm_clear_chat: "Voulez-vous vider ce chat ?",
    confirm_clear_everyone: "Voulez-vous vider ce chat pour les deux ? (OK = Pour tout le monde, Annuler = Seulement pour moi)",
    edit_profile: "Modifier le profil",
    click_to_write_mail: "Cliquez pour écrire un e-mail",
    message_to_channel: "Message à",
    smtp_security_warning: "Ce message a été transmis via le provotole SMTP classique non chiffré. Aucun chiffrement de bout en bout actif.",
    von: "De",
    export_disclosure: "Exporter le dossier de sécurité",
    melden: "Signaler",
    attachments: "Pièces jointes",
    kein_chat_ausgewaehlt: "Aucun chat sélectionné",
    room_chat_start_hint: "Commencez la conversation ! Tous les messages de ce canal de groupe sont décentralisés et chiffrés de bout en bout de manière quantique.",
    kein_kanal_ausgewaehlt: "Aucun canal sélectionné",
    select_channel_chat: "Sélectionnez un canal dans la barre latérale gauche pour discuter.",
    chat_start_hint: "Commencez la conversation ! Tous les messages de discussion sont chiffrés de bout en bout de manière quantique.",
    chat_input_placeholder: "Saisir un message sécurisé...",
    upload_avatar_btn: "Télécharger une image (assainie)",
    kryptographische_schluessel: "Clés cryptographiques",
    profile_unlock_desc: "Pour des raisons de sécurité, vous devez saisir à nouveau votre mot de passe pour afficher vos clés cryptographiques privées.",
    unlock_btn_profile: "Déverrouiller",
    e2e_chat_room_open: "Ouvrir la salle de chat E2E",
    spam_verdacht: "Spam/Suspect",
    no_description: "Pas de description"
  }
};

const LanguageContext = React.createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    return localStorage.getItem('gaia_lang') || 'de';
  });

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguageState(lang);
      localStorage.setItem('gaia_lang', lang);
    }
  };

  const t = (key) => {
    const langData = translations[language] || translations.de;
    return langData[key] || translations.de[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const context = React.useContext(LanguageContext);
  if (!context) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }
  return context;
}
